export const issuesHistoryTable = (data = []) => {
    return (
        data &&
        data.length &&
        data.map((item, index) => {
            const {
                id,
                url,
                http_status_code_client,
                created_at,
                resolved_at,
                down_for,
                clicks_count,
                loss,
                campaigns_count,
                job_id,
            } = item;

            return {
                id,
                url,
                http_status_code_client,
                created_at,
                resolved_at,
                down_for,
                clicks_count,
                loss: '$' + (loss ?? 0),
                campaigns_count,
                job_id,
            };
        })
    );
};

export const issuesHistoryTableTitles = () => {
    return [
        {
            title: "IP",
            alias: "ip",
        },
        {
            title: "Account",
            alias: "account",
        },
        {
            title: "Campaign",
            alias: "campaign",
        },
        {
            title: "Clicked on",
            alias: "created_at",
        },
        {
            title: "Detected",
            alias: "detected",
        },
    ];
};
